import { ACCOUNT_PATHS } from './paths';
import { rememberReturnTo } from './returnTo';

/**
 * AuthKit's settings, from the environment (CONTRACT §7).
 *
 *   VITE_WORKOS_CLIENT_ID     the WorkOS client; the backend's WORKOS_CLIENT_ID
 *                             must be the same one.
 *   VITE_WORKOS_API_HOSTNAME  a custom auth domain (auth.myclimateweek.com).
 *                             With one, the session lives in a secure cookie.
 *   VITE_WORKOS_DEV_MODE      "true" keeps the refresh token in localStorage on
 *                             every host. Unset, the SDK's own default applies:
 *                             on for localhost only.
 *
 * With neither of the last two in production, a reload logs people out. Which
 * one ships is Sam and Conner's call; see DEPLOYMENT.md.
 */

const env = import.meta.env;

/** The client the site has used since accounts first went in. */
const DEFAULT_CLIENT_ID = 'client_01M29JB48BM5HHNWWQN0FB0P00';

const clientId = (env.VITE_WORKOS_CLIENT_ID as string | undefined) || DEFAULT_CLIENT_ID;
const apiHostname = (env.VITE_WORKOS_API_HOSTNAME as string | undefined) || undefined;
// Undefined rather than false when unset, so the SDK's localhost default holds.
const devMode = env.VITE_WORKOS_DEV_MODE === 'true' ? true : undefined;

/** Absolute, as AuthKit compares its pathname with the page's. */
const redirectUri = new URL(
  `${import.meta.env.BASE_URL.replace(/\/+$/, '')}${ACCOUNT_PATHS.callback}`,
  window.location.origin,
).href;

export const AUTHKIT_OPTIONS = {
  clientId,
  apiHostname,
  devMode,
  redirectUri,
  onRedirectCallback: ({ state }: { state: unknown }) => rememberReturnTo(state),
};
